module.exports = __webpack_public_path__ + "fonts/dee9397ec0881599c9a45256d41a49c9.woff2";